import moment from 'moment-timezone';
import { call } from 'redux-saga/effects';
import { get, filter } from 'lodash';
import crypto from 'crypto';
// using the /max instace to add landlines verification
import request from 'utils/request';

export function* sleep(time) {
  yield new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}

export function parseDateFromNow(value) {
  if (!value) {
    return '';
  }
  return moment(value).fromNow();
}

export function* quiteRequest(endpoint) {
  try {
    const response = yield call(request, endpoint);

    return response && !response.isAppError ? response : undefined;
  } catch (err) {
    return undefined;
  }
}

export function formatPracticeLinkName(name) {
  return name
    ? name
        .toLowerCase()
        .replace(/\s/g, '-')
        .replace(/\W/g, '')
    : 'invalid';
}

export function generateHash(key) {
  return crypto
    .createHash('md5')
    .update(key)
    .digest('hex');
}

export function setTextAreaCaretPosition(input, position) {
  setTextAreaSelectionRange(input, position, position);
}

export function setTextAreaSelectionRange(input, selectionStart, selectionEnd) {
  if (input.setSelectionRange) {
    input.focus();
    input.setSelectionRange(selectionStart, selectionEnd);
  } else if (input.createTextRange) {
    const range = input.createTextRange();

    range.collapse(true);
    range.moveEnd('character', selectionEnd);
    range.moveStart('character', selectionStart);
    range.select();
  }
}
